import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/useAuth";
import { setTokenGetter } from "@/services/api-client";

export function useAuthGuard() {
  const location = useLocation();
  const {
    user,
    profile,
    loading,
    isConfigured,
    accountDisabled,
    signOut,
    getToken,
    refreshProfile,
  } = useAuth();

  useEffect(() => {
    if (isConfigured) {
      setTokenGetter(getToken);
    }
    return () => {
      setTokenGetter(null);
    };
  }, [isConfigured, getToken]);

  const isAuthenticated = Boolean(user);
  const requiresAuth = !isAuthenticated && location.pathname !== "/login";

  return {
    user,
    profile,
    loading,
    isConfigured,
    accountDisabled,
    signOut,
    isAuthenticated,
    requiresAuth,
    pathname: location.pathname,
    refreshProfile,
  };
}
